import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Avatar, Typography, Descriptions, Upload, Button, message } from 'antd';
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    HomeOutlined,
    FileTextOutlined,
    BankOutlined,
    UploadOutlined
} from '@ant-design/icons';

import { FIRM_USER_ID, FIRMUSERID, AUTH_TOKEN, FIRM_NAME } from 'constants/StorageConstant';
import network from 'network/network';
import { API_FULL_URL } from 'constants/ApiConstant';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getFirmSettings } from 'utils/redux/reducers/firmSettingsReducer';

const { Title, Text } = Typography;

const UserProfile = () => {

    const dispatch = useDispatch();
    const firmSetting = useSelector(store => store.firmSettings.data);
    const [userData, setUserData] = useState({});
    const [avatarUrl, setAvatarUrl] = React.useState(userData.avatar);
    const [settings, setSettings] = useState();

    useEffect(() => {
        const fetchUserDetails = async () => {
            const firmUserId = localStorage.getItem(FIRMUSERID);
            if (firmUserId) {
                try {
                    const response = await network.get('/admin/Firm/selectUserDetails?firmUserId=' + firmUserId);
                    if (response.data && response.data.isSuccess) {
                        setUserData(response.data.data);
                    } else {
                        console.error("Failed to fetch user details:", response.data.message);
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error);
                }
            }
        };

        fetchUserDetails();
    }, []);

    useEffect(() => {
        dispatch(getFirmSettings())
    }, [])

    useEffect(() => {

        console.log("DAAAAAAATAAAAAAAA", firmSetting.data)
    }, [firmSetting])

    const handleUpload = (id) => ({
        name: 'file',
        action: API_FULL_URL + `/admin/CoffeeSettings/uploadProfileMedia?firmSettingsId=${id}`,
        method: 'POST',
        headers: {
            authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        },
        showUploadList: false,
        onChange(info) {
            if (info.file.status === 'done') {

                dispatch(getFirmSettings());

            } else if (info.file.status === 'error') {
                message.error("Hata");
            }
        }

    });

    const firmsettingsid = firmSetting?.data?.firmsettingsid || 0;
    return (
        <Row gutter={24}>
            <Col xs={24} sm={24} md={8} lg={7} xl={6}>
                <Card style={{ marginTop: "25px" }}>
                    <div style={{ textAlign: 'center' }}>
                        <Avatar size={120} src={firmSetting?.data?.profilemediapath} icon={<UserOutlined />} />
                        <div style={{ marginTop: 16 }}>
                            <Title level={4} style={{ marginTop: '1rem' }}>{`${localStorage.getItem(FIRM_NAME)}`} </Title>
                            <Upload maxCount={1} {...handleUpload(firmsettingsid)} >
                                <Button style={{ width: "120px" }} icon={<UploadOutlined />}>
                                    Upload
                                </Button>
                            </Upload>
                        </div>
                    </div>
                </Card>
            </Col>
            <Col xs={24} sm={24} md={16} lg={17} xl={18}>
                <Card title="Yetkili Bilgileri" style={{ marginTop: "25px", marginBottom: "16px" }}>
                    <Descriptions
                        bordered
                        column={1}
                        labelStyle={{ fontWeight: 'bold', padding: '1.5rem' }}
                        contentStyle={{ padding: '1.5rem', fontSize: "15px" }}
                    >
                        <Descriptions.Item label={<><UserOutlined style={{ marginRight: '8px' }} />Name Surname</>}>{userData.namesurname}</Descriptions.Item>
                        <Descriptions.Item label={<><MailOutlined style={{ marginRight: '8px' }} />Email</>}>{userData.email}</Descriptions.Item>
                        <Descriptions.Item label={<><UserOutlined style={{ marginRight: '8px' }} />Title</>}>{userData.usertitle}</Descriptions.Item>
                        <Descriptions.Item label={<><PhoneOutlined style={{ marginRight: '8px' }} />Phone Number</>}>{userData.phonenumber}</Descriptions.Item>
                    </Descriptions>
                </Card>
                <Card title="Firma Bilgileri" style={{ marginTop: "0" }}>
                    <Descriptions
                        bordered
                        column={1}
                        labelStyle={{ fontWeight: 'bold', padding: '1.5rem' }}
                        contentStyle={{ padding: '1.5rem', fontSize: "15px" }}
                    >
                        <Descriptions.Item label={<><HomeOutlined style={{ marginRight: '8px' }} />Address</>}>{userData.address}</Descriptions.Item>
                        <Descriptions.Item label={<><BankOutlined style={{ marginRight: '8px' }} />Tax Office</>}>{userData.taxoffice}</Descriptions.Item>
                        <Descriptions.Item label={<><FileTextOutlined style={{ marginRight: '8px' }} />Tax Code</>}>{userData.taxcode}</Descriptions.Item>
                    </Descriptions>
                </Card>
            </Col>
        </Row>
    );
};

export default UserProfile;
